import { Component, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { Subject, takeUntil, tap } from "rxjs";
import {
  BreakpointObserver,
  Breakpoints,
  LayoutModule,
} from "@angular/cdk/layout";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "app-contact-support-info",
    templateUrl: "./contact-support-info.html",
    styleUrl: "./contact-support.component.scss",
    imports: [MatDividerModule, MatDialogModule, MatListModule, MatIconModule]
})
export class ContactSupportInfoComponent {
  constructor(private dialogRef: MatDialogRef<ContactSupportComponent>) {}

  openLink(event: MouseEvent): void {
    this.dialogRef.close();
    event.preventDefault();
  }
}

@Component({
    selector: "app-contact-support",
    imports: [MatIconModule, MatButtonModule, LayoutModule],
    templateUrl: "./contact-support.component.html",
    styleUrl: "./contact-support.component.scss"
})
export class ContactSupportComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(
        tap((result) => {
          this.isMobile = result.matches;
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }
  isMobile = false;
  destroyed$ = new Subject();

  ngOnInit() {}

  openBottomSheet(): void {
    this.dialog.open(ContactSupportInfoComponent, {
      position: this.isMobile
        ? null
        : {
            bottom: "2vh",
            right: "100px",
          },
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(1);
    this.destroyed$.unsubscribe();
  }
}
